var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTextPage = function SvgTextPage(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2.5C0.5 1.11929 1.61929 0 3 0H10.5C10.7652 0 11.0196 0.105357 11.2071 0.292893L17.2071 6.29289C17.3946 6.48043 17.5 6.73478 17.5 7V19.5C17.5 20.8807 16.3807 22 15 22H3C1.61929 22 0.5 20.8807 0.5 19.5V2.5ZM3 2C2.72386 2 2.5 2.22386 2.5 2.5V19.5C2.5 19.7761 2.72386 20 3 20H15C15.2761 20 15.5 19.7761 15.5 19.5V7.41421L10.0858 2H3Z",
    fill: "#8290A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1173 0.0761211C10.491 -0.0786599 10.9211 0.00689584 11.2071 0.292894L17.2071 6.29289C17.4931 6.57889 17.5787 7.00901 17.4239 7.38268C17.2691 7.75636 16.9045 8 16.5 8H10.5C9.94772 8 9.5 7.55229 9.5 7V1C9.5 0.595538 9.74364 0.230902 10.1173 0.0761211ZM11.5 3.41421V6H14.0858L11.5 3.41421Z",
    fill: "#8290A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 12C4.5 11.4477 4.94772 11 5.5 11H12.5C13.0523 11 13.5 11.4477 13.5 12C13.5 12.5523 13.0523 13 12.5 13H5.5C4.94772 13 4.5 12.5523 4.5 12Z",
    fill: "#8290A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 16C4.5 15.4477 4.94772 15 5.5 15H10.5C11.0523 15 11.5 15.4477 11.5 16C11.5 16.5523 11.0523 17 10.5 17H5.5C4.94772 17 4.5 16.5523 4.5 16Z",
    fill: "#8290A2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTextPage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/text-page.9ec91a69.svg";
export { ForwardRef as ReactComponent };